import { useEffect, useMemo } from 'react';
import Heading from 'components/design-system/Heading/Heading';
import Table from 'components/design-system/Table/Table';
import Text from 'components/design-system/Text/Text';
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import { formatoFechaHora } from 'helpers/formatFecha';
import { useEstadosSolicitarAdministracion } from './hooks/useEstadosSolicitarAdministracion';
import { DetalleDestinatarios } from './componentes/DetalleDestinatarios';
import { DICTONARY } from 'const/Dictonary';

export const EstadosSolicitarAdministracion = () => {
  const {
    solicitudCargarSolicitudes,
    pagination,
    columnFilters,
    getColumnaEstado,
    getReenviarButton,
    getEtiquetaEstado,
    dataTabla,
    rowCount,
    setPagination,
    isLoading,
    globalFilter,
    setColumnFilters,
    setGlobalFilter
  } = useEstadosSolicitarAdministracion();

  useEffect(() => {
    solicitudCargarSolicitudes();
  }, [pagination.pageIndex, pagination.pageSize, columnFilters]);

  const columnTables = useMemo(
    () => [
      {
        header: 'Código',
        accessorKey: 'codigoSolicitud',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        size: 40,
        enableColumnActions: false,
        enableColumnFilter: false
      },
      {
        header: 'Destinatario',
        accessorKey: 'destinatario',
        Cell: ({ renderedCellValue }) => (
          <Text>{renderedCellValue.titulo}</Text>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false
      },
      {
        header: 'Estado',
        accessorKey: 'estado',
        Cell: ({ renderedCellValue }) => (
          <div>
            {getColumnaEstado(renderedCellValue)}
            {(renderedCellValue.tipo ===
              DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.EMPRESA ||
              renderedCellValue.tipo ===
                DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.SUCURSAL) &&
              getReenviarButton(
                renderedCellValue,
                renderedCellValue.codigoSolicitud
              )}
          </div>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false
      },
      {
        header: 'Fecha y hora',
        accessorKey: 'fechaEnvio',
        Cell: ({ renderedCellValue }) => (
          <Text>
            {renderedCellValue ? formatoFechaHora(renderedCellValue) : '-'}
          </Text>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 40
      }
    ],
    []
  );

  return (
    <SidebarLayout>
      <div className="mb-10">
        <div className="flex flex-col sm:flex-row sm:items-center mb-4 sm:justify-between gap-4">
          <div className="mb-5">
            <Heading type="h2">Seguimiento de solicitudes enviadas</Heading>
            <Text>
              Revisa el estado de las solicituds de administración que has
              enviado
            </Text>
          </div>
        </div>

        <Table
          headTable={
            <Heading type="h4" className="p-2">
              Negocios registrados
            </Heading>
          }
          data={dataTabla}
          columns={columnTables}
          isLoading={isLoading}
          rowCount={rowCount}
          manualFiltering
          enableGlobalFilter={false}
          enableFilters={false} // Oculta botón de filtros
          onPaginationChange={setPagination}
          state={{
            columnFilters,
            pagination,
            isLoading,
            showProgressBars: false,
            globalFilter,
            columnOrder: [
              'codigoSolicitud',
              'mrt-row-expand',
              'destinatario',
              'estado',
              'fechaEnvio'
            ]
          }}
          manualPagination
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          renderDetailPanel={({ row }) =>
            row.original.destinatario.detalle ? (
              <DetalleDestinatarios
                tipo={row.original.estado.tipo}
                data={row.original.destinatario.detalle}
                id={row.original.codigoSolicitud}
                getEtiquetaEstado={getEtiquetaEstado}
                getReenviarButton={getReenviarButton}
              />
            ) : null
          }
          enableExpandAll={false}
          muiExpandButtonProps={({ row, table }) => ({
            onClick: () =>
              table.setExpanded({ [row.id]: !row.getIsExpanded() }),
            sx: {
              transform: row.getIsExpanded()
                ? 'rotate(180deg)'
                : 'rotate(-90deg)',
              transition: 'transform 0.2s'
            }
          })}
          displayColumnDefOptions={{
            'mrt-row-expand': { header: '' }
          }}
          muiDetailPanelProps={() => ({
            sx: theme => ({
              backgroundColor: 'rgba(0, 0, 0, 0.05)'
            })
          })}
          muiTableHeadCellProps={{
            sx: {
              fontFamily: 'Poppins, sans-serif',
              fontSize: '13px'
            }
          }}
        />
      </div>
    </SidebarLayout>
  );
};
